import { FlyerTemplateCreatorState } from "../types/flyer-template-creator-state/flyer-template-creator-state.interface";
import {
  createFlyerEmptyTemplate,
  createFlyerTemplateCreatorState,
} from "../types/flyer-template-creator-state/flyer-template-creator-state.functions";
import {
  FlyerTemplateCreatorActions,
  FlyerTemplateCreatorActionsType,
} from "./flyer-template-creator.actions";
import { FlyerTemplate } from "../../../features/flyer-template/types/flyer-template/flyer-template.interface";

export function flyerTemplateCreatorReducer(
  state = createFlyerTemplateCreatorState(),
  action: FlyerTemplateCreatorActionsType
): FlyerTemplateCreatorState {
  switch (action.type) {
    case FlyerTemplateCreatorActions.SetTemplateName:
      return {
        ...state,
        template: {
          ...state.template,
          name: action.payload,
        } as FlyerTemplate,
      };
    case FlyerTemplateCreatorActions.AddRow:
    case FlyerTemplateCreatorActions.RemoveRow:
    case FlyerTemplateCreatorActions.SetRows:
    case FlyerTemplateCreatorActions.AddColumn:
    case FlyerTemplateCreatorActions.RemoveColumn:
    case FlyerTemplateCreatorActions.SetColumns:
    case FlyerTemplateCreatorActions.RemovePosition:
    case FlyerTemplateCreatorActions.SavePositionDetails:
    case FlyerTemplateCreatorActions.Save:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerTemplateCreatorActions.SetCanvas:
      return {
        ...state,
        canvas: action.payload,
      };
    case FlyerTemplateCreatorActions.SetGrid:
      return {
        ...state,
        grid: action.payload,
      };
    case FlyerTemplateCreatorActions.SetTemplate:
    case FlyerTemplateCreatorActions.SaveSuccess:
      return {
        ...state,
        template: action.payload,
        isLoading: false,
      };
    case FlyerTemplateCreatorActions.SaveFailure:
      return {
        ...state,
        errors: action.payload,
        isLoading: false,
      };
    case FlyerTemplateCreatorActions.SetEditingPosition:
      return {
        ...state,
        editingPosition: action.payload,
      };
    case FlyerTemplateCreatorActions.SavePositionDetailsSuccess:
      return {
        ...state,
        isLoading: false,
        editingPosition: null,
      };
    case FlyerTemplateCreatorActions.Reset:
      return {
        ...state,
        editingPosition: null,
        errors: null,
        isLoading: false,
        template: createFlyerEmptyTemplate(),
      };
    default:
      return state;
  }
}
